export default {"src":"/_next/static/media/icon-pop-up.9f4d14da.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};